module.exports = __webpack_public_path__ + "assets/images/project/pin.svg?v=04ec15eb";